<template>
  <v-btn class="ml-2" color="success"
    v-show="data"
    @click="exportToExcel"
    :loading="isLoading"
  >
    <v-icon>{{ mdiFileExcel }}</v-icon>
  </v-btn>
</template>

<script>
import { json2excel } from 'js2excel';
import { mdiFileExcel } from '@mdi/js';

export default {
  name: 'ExportToExcel',
  props: ['data', 'name'],
  data() {
    return {
      mdiFileExcel,
      isLoading: false,
    };
  },
  methods: {
    async exportToExcel() {
      this.isLoading = true;
      const { data, name } = this;
      await json2excel({
        data,
        name,
        formateDate: 'yyyy/mm/dd',
      });
      this.isLoading = false;
    },
  },
};
</script>
